import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PopupLeadstatusComponent } from './popup-leadstatus.component';

const routes: Routes = [{ path: '', component: PopupLeadstatusComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PopupLeadstatusRoutingModule { }
